import {
  axios,
  config
} from '../api'
import store from '../store'

let prop = {}

// 获取产权修改信息
prop.getEditDto = (_ID) => {
  return axios('post', config.API_URL + '/api/Prop/GetEditDto', {},{
    ID: _ID
  })
}

prop.add = {
  data: {
    PropNum: "",//产权证号
    ProjName: "",//项目
    Area: 0,//面积
    Province: "",
    City: "",
    County: "",
    Address: "",
    Latitude: 0,
    Longitude: 0,
    FileList:[],
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Prop/Add', _data)
  }
}

prop.edit = {
  data: {
    PropNum: "", //产权证号
    ProjName: "", //项目
    Area: 0, //面积
    Province: "",
    City: "",
    County: "",
    Address: "",
    Latitude: 0,
    Longitude: 0,
    FileList:[],
    Notes:''
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Prop/Edit', _data)
  }
}

prop.del = (_idList) => {
  return axios('post', config.API_URL + '/api/Prop/Del',{}, {
    idList: _idList
  })
}

prop.getList = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Prop/GetList', _data)
  }
}

prop.export = {
  data: {
    PageIndex: 1,
    PageSize: 10,
    CondList: [
      {
        Key: "",
        Operator: "",
        Value: ""
      }
    ]
  },
  post(_data) {
    _data = _data ? _data : this.data
    return axios('post', config.API_URL + '/api/Prop/ExportList',_data,{},1)
  }
}
// 末尾传个参数，就是blob类型，具体查询api/index.js中的axios函数

export default prop



